const postRoles = {
  toastr: 'Função adicionada',
  toastr: ' foi adicionado com sucesso',
  toastrError: 'Função já cadastrada',
  toastrError: 'Insira outro nome'
};

export default postRoles;
